export default "__VITE_ASSET__$uWLb_VA__"